import ChatAnimation from "./ChatAnimation";
import playBtn from "../assets/images/playbtn.png";
import pauseBtn from "../assets/images/pausebtn.png";
import React from "react";
import {setWelcomeVideoPlay, updateCartDOMRects} from "../store/reducers/questionReducer";
import {useDispatch, useSelector} from "react-redux";
import {VideoControls} from "./Videocontrols";

interface IProps {
    welcome: string
}

export const Welcome = (props: IProps) => {
    const dispatch = useDispatch();
    const {welcome} = props;
    const [play, setPlay] = React.useState<boolean>(false);
    const welcomeVideo = React.createRef<HTMLVideoElement>();

    const [muted, setMuted] = React.useState<boolean>(false);
    const [duration, setDuration] = React.useState<any>(0);
    const [currentVideoTime, setCurrentVideoTime] = React.useState<number>(0);

    const profilePath = useSelector((state: any) => state.questionReducer.profilePath);

    const playVideo = () => {
        if (welcomeVideo.current) {
            if (play === false) {

                const data: any = playBtnRef.current.getBoundingClientRect();
                data['key'] = Math.random();
                data['play'] = true;
                dispatch(updateCartDOMRects(data));

                dispatch(setWelcomeVideoPlay(true));

                const welcomeRef = welcomeVideo.current;
                setTimeout(() => {
                    welcomeRef.play();
                    setPlay(true);
                }, 1000)

            } else {
                const data: any = pauseBtnRef.current.getBoundingClientRect();
                data['key'] = Math.random();
                data['play'] = false;
                dispatch(updateCartDOMRects(data));
                setTimeout(() => {
                    dispatch(setWelcomeVideoPlay(false));
                }, 1000)
                setPlay(false);

                welcomeVideo.current.pause();
            }
        }
    }
    const handleVideoEnded = () => {
        dispatch(setWelcomeVideoPlay(false));
        setPlay(false);
    }
    const handleLoadedMetadata = () => {
        const video: any = welcomeVideo.current;
        if (!video) return;

        setDuration(video.duration);
    };
    const videoTimeUpdate = (e: any) => {
        const video: any = welcomeVideo.current;
        if (!video) return;

        setCurrentVideoTime(video.currentTime);

    }

    const playBtnRef: any = React.createRef();
    const pauseBtnRef: any = React.createRef();

    let welcomeVideoUrl = '';
    let welcomeVideoThumbUrl = '';
    if (profilePath === 'edo-segal') {
        welcomeVideoUrl = 'https://demoassets.touchcast.com/profile-assets/video.mp4';
        welcomeVideoThumbUrl = 'https://demoassets.touchcast.com/profile-assets/1.png';
    } else if (profilePath === 'david' || profilePath === 'david-shrier') {
        welcomeVideoUrl = 'https://demoassets.touchcast.com/profile-assets/David/david_welcome.mp4';
        welcomeVideoThumbUrl = 'https://demoassets.touchcast.com/profile-assets/David/david_welcome.jpg';
    } else if (profilePath === 'sky') {
        welcomeVideoUrl = 'https://demoassets.touchcast.com/profile-assets/sky/sky_welcome.mp4';
        welcomeVideoThumbUrl = 'https://demoassets.touchcast.com/profile-assets/sky/sky_welcome.jpeg';
    } else if (profilePath === 'will-knight') {
        welcomeVideoUrl = 'https://demoassets.touchcast.com/profile-assets/will/will_welcome.mp4';
        welcomeVideoThumbUrl = 'https://demoassets.touchcast.com/profile-assets/will/will_welcome.jpeg';
    } else if (profilePath === 'allisonhorn') {
        welcomeVideoUrl = 'https://demoassets.touchcast.com/profile-assets/allisonhorn/allisonhorn_welcome.mp4';
        welcomeVideoThumbUrl = 'https://demoassets.touchcast.com/profile-assets/allisonhorn/allisonhorn_welcome.jpeg';
    }


    return (
        <div className="tc-chat-welcome-screen">
            {welcomeVideoUrl != '' &&
                <div className={`tc-chat-welcome-video ${play ? 'pause' : 'play'}`}>
                    <video ref={welcomeVideo}
                           src={welcomeVideoUrl}
                           onEnded={handleVideoEnded}
                           onLoadedMetadata={handleLoadedMetadata}
                           onTimeUpdate={videoTimeUpdate}
                           playsInline={true}
                           webkit-playsinline="true"
                    ></video>
                    {play === true &&
                        <VideoControls
                            currentVideoTime={currentVideoTime} duration={duration}
                            videoEl={welcomeVideo} muted={muted} setMuted={setMuted} playing={play}
                            playVideo={playVideo}/>
                    }

                    {welcomeVideoThumbUrl != '' &&
                        <img className="thumbnail-slide" src={welcomeVideoThumbUrl} alt=""/>
                    }
                    <a ref={playBtnRef} href="#" className="playbtn" onClick={playVideo}>
                        <img src={playBtn} alt=""/>
                    </a>
                    <a ref={pauseBtnRef} href="#" className="pausebtn" onClick={playVideo}>
                        <img src={pauseBtn} alt=""/>
                    </a>
                </div>
            }
            <div className="tc-chat-welcome-msg">
                <ChatAnimation key={'welcome'} identifier='welcome' chatAnswer={welcome}
                               initialDelay={window.chatOnly ? 0 : 3}
                               wordDelay={0.2}
                               classNameBeforeDelay={'tc-type-animation-thinking'}
                               classNameAfterDelay={''}
                />
            </div>
        </div>
    )
}
